export default "/images/d3ac0d48bc10b95c2bf890c5cee62d3c.avif";